"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useFontSize = (rem) => {
    return (rem * parseFloat(window.getComputedStyle(document.documentElement).fontSize));
};
exports.default = useFontSize;
